import {CLIPART, CLIPART_CATEGORIES, CLIPART_LIMITS} from '../actions'

const initialState = {
  clipart: {},
  categories: {},
  limits: {}
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CLIPART.SUCCESS:
      return {
        ...state,
        clipart: action.response.entities.clipart || [],
      };
    case CLIPART_CATEGORIES.SUCCESS:
      return {
        ...state,
        categories: action.response.entities.category || [],
      }
    case CLIPART_LIMITS.SUCCESS:
      return {
        ...state,
        limits: action.response.entities.limit || [],
      }
    default:
      return state;
  }
}
